export enum DeliveryServiceEnum {
  // AUSTRIAN_POST = 'Austrian Post',
  AUSTRIAN_POST = 'AUSTRIAN_POST',
  DHL = 'DHL',
  UPS = 'UPS',
  DPD = 'DPD',
  GLS = 'GLS',
  USER_DEFINED = 'USER_DEFINED',
}
